// Chatbot question matching logic
export const chatbotKnowledge = {
  en: [
    {
      keywords: ['services', 'offer', 'provide', 'service'],
      question: 'What services do you offer?',
      answer: 'We offer Web Development, Mobile App Development, Graphics Design, Digital Marketing, IT Consultancy, and CCTV camera installation.',
    },
    {
      keywords: ['how long does a website', 'website take', 'website timeline', 'website duration'],
      question: 'How long does a website take?',
      answer: 'A standard business website usually takes 2 to 4 weeks. A larger custom website or web application can take 4 to 8 weeks after we agree on the features.',
    },
    {
      keywords: ['time', 'duration', 'how long', 'project timeline'],
      question: 'How long does a project take?',
      answer: 'Project timelines depend on scope and complexity. We provide a clear timeline after a complete assessment.',
    },
    {
      keywords: ['support', 'after', 'completion', 'maintenance', 'help', 'assist'],
      question: 'Do you provide support after completion?',
      answer: 'Yes! All our clients receive 24/7 support and maintenance services.',
    },
    {
      keywords: ['technology', 'tech', 'tools', 'frameworks', 'languages'],
      question: 'What technologies do you use?',
      answer: 'We use modern technologies - React, Node.js, Python, TypeScript, and other industry-standard tools.',
    },
    {
      keywords: ['cctv', 'camera', 'security camera', 'surveillance', 'nvr'],
      question: 'Do you install CCTV cameras?',
      answer: 'Yes. We install and configure CCTV systems for homes, offices, clinics, and commercial buildings, including remote viewing on your phone.',
    },
    {
      keywords: ['website', 'company website', 'web design', 'landing page'],
      question: 'Can you build a website for my business?',
      answer: 'Yes. We design and develop company websites, clinic websites, landing pages, and e-commerce sites with hosting and maintenance.',
    },
    {
      keywords: ['office', '306', 'peony', 'jemo', 'peony'],
      question: 'What is your full office address?',
      answer: 'Addis Ababa, Jemo Michael, Peony Commercial Building, Office No. 306/A.',
    },
    {
      keywords: ['integrate', 'existing', 'system', 'connect', 'compatible'],
      question: 'Can you integrate with existing systems?',
      answer: 'Absolutely! We provide integration services - we can work with any existing system.',
    },
    {
      keywords: ['price', 'cost', 'fee', 'pricing', 'charge', 'expensive'],
      question: 'What are your pricing options?',
      answer: 'Pricing depends on project requirements. We provide reasonable quotes and timelines - contact us for details.',
    },
    {
      keywords: ['maintenance', 'updates', 'ongoing', 'support', 'monitoring'],
      question: 'Do you offer maintenance services?',
      answer: 'Yes! We provide continuous maintenance, updates, and ongoing support.',
    },
    {
      keywords: ['process', 'development', 'how', 'workflow', 'steps', 'approach'],
      question: 'What is your development process?',
      answer: 'We use Agile development process - direct communication, regular updates, and solution reviews.',
    },
    {
      keywords: ['hosting', 'deployment', 'server', 'launch', 'deploy'],
      question: 'Do you help with hosting and deployment?',
      answer: 'Yes! We provide complete hosting and deployment support.',
    },
    {
      keywords: ['start', 'begin', 'contact', 'work', 'hire', 'get started'],
      question: 'How do I get started?',
      answer: 'Simple! Contact us through our contact form, WhatsApp (+251 979 235 206), or Telegram (@fortinotech), and we will have a consultation about your project.',
    },
    {
      keywords: ['whatsapp', 'telegram', 'live chat', 'livechat', 'chat with', 'message you', 'talk to a person', 'human'],
      question: 'How can I live chat with your team?',
      answer: 'You can chat with our team live on WhatsApp at +251 979 235 206 or on Telegram at @fortinotech. Use the WhatsApp and Telegram buttons in this chat window.',
    },
    {
      keywords: ['hello', 'hi', 'hey', 'greetings'],
      question: 'Greeting',
      answer: 'Hello!  How can I assist you today?'
    },
    {
      keywords: ['good morning', 'morning'],
      question: 'Morning Greeting',
      answer: 'Good morning!  Ready to discuss your project?'
    },
    {
      keywords: ['good afternoon', 'afternoon'],
      question: 'Afternoon Greeting',
      answer: 'Good afternoon! How can I help you today?'
    },
    {
      keywords: ['good evening', 'evening'],
      question: 'Evening Greeting',
      answer: 'Good evening!  Need assistance with a project?'
    },
    {
      keywords: ['thanks', 'thank you', 'thx'],
      question: 'Thank You',
      answer: "You're welcome!  Is there anything else I can help you with?"
    },
    {
      keywords: ['bye', 'goodbye', 'see you', 'later'],
      question: 'Goodbye',
      answer: 'Goodbye! Have a great day and feel free to reach out anytime.'
    },
    {
      keywords: ['joke', 'funny', 'laugh'],
      question: 'Tell a joke',
      answer: "Why did the developer go broke? Because he used up all his cache! "
    },
    {
      keywords: ['portfolio', 'projects', 'work examples'],
      question: 'Portfolio',
      answer: 'You can check our portfolio section on the homepage to see our completed projects.'
    },
    {
      keywords: ['reviews', 'testimonials', 'feedback', 'clients'],
      question: 'Testimonials',
      answer: 'Yes! Check our Testimonials section to see what our clients say about us.'
    },
    {
      keywords: ['training', 'guide', 'manual', 'help'],
      question: 'Training and Documentation',
      answer: 'We provide training sessions and full documentation for all projects to help you manage your systems easily.'
    },
    {
      keywords: ['emergency', 'urgent support', 'critical'],
      question: 'Emergency Support',
      answer: 'We provide urgent support for critical issues at any time.'
    },
    {
      keywords: ['custom', 'tailored', 'personalized'],
      question: 'Custom Solutions',
      answer: 'We create tailored solutions to fit your unique business needs.'
    },
    {
      keywords: ['scalable', 'growth', 'expand'],
      question: 'Scalable Systems',
      answer: 'Our systems are built to grow with your business, ensuring long-term scalability.'
    },
    {
      keywords: ['security', 'safe', 'protection', 'secure'],
      question: 'Security',
      answer: 'We implement industry-standard security measures to keep your projects safe and secure.'
    },
    {
      keywords: ['analytics', 'report', 'data', 'metrics'],
      question: 'Analytics',
      answer: 'We provide analytics tools to track and improve your project’s performance.'
    },
    {
      keywords: ['ecommerce', 'shop', 'store', 'online'],
      question: 'Ecommerce Solutions',
      answer: 'We build online stores with secure payment integration and smooth user experience.'
    },
    {
      keywords: ['branding', 'logo', 'identity', 'brand'],
      question: 'Branding',
      answer: 'We help create strong brand identities with logos, graphics, and design assets.'
    },
    {
      keywords: ['social media', 'facebook', 'instagram', 'ads'],
      question: 'Social Media Marketing',
      answer: 'We manage social media campaigns to increase visibility and engagement for your brand.'
    },
    {
      keywords: ['seo', 'search engine optimization', 'google rank'],
      question: 'SEO',
      answer: 'We optimize websites to rank higher on search engines and drive organic traffic.'
    },
    {
      keywords: ['ads', 'advertisement', 'campaign', 'promote'],
      question: 'Advertising',
      answer: 'We create ad campaigns that drive traffic, leads, and sales for your business.'
    },
    {
      keywords: ['how', 'contact', 'start', 'hire', 'begin'],
      question: 'How to Get Started',
      answer: 'Simple! Contact us through our contact form, email, or Facebook to start discussing your project.'
    },
    {
      keywords: ['workflow', 'process', 'steps', 'approach'],
      question: 'Development Process',
      answer: 'We follow Agile methodology, providing regular updates and client communication at every step.'
    },
    {
      keywords: ['updates', 'ongoing', 'support', 'monitoring', 'maintenance'],
      question: 'Ongoing Support',
      answer: 'Yes! We provide continuous maintenance, updates, and monitoring for all our projects.'
    },
    {
      keywords: ['timeline', 'duration', 'schedule', 'deadline'],
      question: 'Project Timeline',
      answer: 'Project timelines depend on complexity and scope. We provide a detailed schedule after assessment.'
    },
    {
      keywords: ['tools', 'software', 'framework', 'languages', 'tech'],
      question: 'Technologies Used',
      answer: 'We use modern technologies like React, Node.js, Python, TypeScript, and other industry-standard tools.'
    },
    {
      keywords: ['integration', 'connect', 'compatible', 'existing system'],
      question: 'System Integration',
      answer: 'Absolutely! We can integrate with your existing systems seamlessly.'
    },
    {
      keywords: ['deployment', 'hosting', 'server', 'launch'],
      question: 'Hosting & Deployment',
      answer: 'We provide complete hosting, server setup, and deployment support.'
    }
,
    {
      keywords: ['payment', 'telebirr', 'cbebirr', 'chapa', 'integration'],
      question: 'Do you support local payment integrations?',
      answer: 'Yes! FortinoTech specializes in integrating local gateways like Telebirr, CBEBirr, Chapa, and Amole into your systems.',
    },
    {
      keywords: ['location', 'office', 'addis ababa', 'address', 'visit'],
      question: 'Where is your office located?',
      answer: 'Our office is in Addis Ababa, Jemo Michael, Peony Commercial Building, Office No. 306/A. You can visit us for in-person consultations.',
    },
    {
      keywords: ['languages', 'amharic', 'local', 'translation'],
      question: 'Can you develop software in local languages?',
      answer: 'Absolutely. We build localized systems supporting Amharic, Afaan Oromoo, and other Ethiopian languages for better accessibility.',
    },
    {
      keywords: ['offline', 'internet', 'connectivity', 'local network'],
      question: 'Do you provide solutions for low-connectivity areas?',
      answer: 'Yes, we design "offline-first" applications that work on local networks or without stable internet, perfect for the Ethiopian context.',
    },
    {
      keywords: ['legal', 'license', 'registered', 'ethiopia'],
      question: 'Is FortinoTech a registered company?',
      answer: 'Yes, FortinoTech is a fully licensed and legally registered IT firm in Addis Ababa, Ethiopia.',
    },
    // --- INDUSTRY SPECIFIC SOLUTIONS ---
    {
      keywords: ['hospital', 'clinic', 'medical', 'healthcare', 'patient'],
      question: 'Do you offer healthcare software?',
      answer: 'Yes! We develop Hospital Management Systems (HMS), patient record tracking, and pharmacy management tools.',
    },
    {
      keywords: ['school', 'university', 'student', 'education', 'learning', 'lms'],
      question: 'Do you build educational platforms?',
      answer: 'We create Learning Management Systems (LMS), student portals, and school administration software.',
    },
    {
      keywords: ['hotel', 'booking', 'reservation', 'tourism'],
      question: 'Can you build a hotel booking system?',
      answer: 'Certainly. We develop custom reservation engines with real-time availability and local payment integration.',
    },
    {
      keywords: ['real estate', 'property', 'house', 'listing', 'rent'],
      question: 'Do you provide real estate solutions?',
      answer: 'Yes, we build property listing platforms with map integrations and lead management for brokers.',
    },
    {
      keywords: ['delivery', 'logistics', 'tracking', 'courier', 'shipping'],
      question: 'Do you develop delivery apps?',
      answer: 'We build logistics software including driver apps, real-time GPS tracking, and dispatch dashboards.',
    },
    {
      keywords: ['restaurant', 'menu', 'food', 'order'],
      question: 'Do you offer restaurant management systems?',
      answer: 'Yes, we provide digital menus, online ordering systems, and POS integration for restaurants.',
    },
    {
      keywords: ['microfinance', 'bank', 'sacco', 'equb', 'finance'],
      question: 'Can you build a system for a Sacco or Equb?',
      answer: 'We specialize in Fintech, including digital Equb platforms and Sacco management software with Telebirr integration.',
    },
    {
      keywords: ['inventory', 'stock', 'warehouse', 'store management'],
      question: 'Do you provide inventory management?',
      answer: 'Yes, our systems help you track stock levels, sales, and orders in real-time.',
    },
    {
      keywords: ['startup', 'mvp', 'prototype', 'new idea'],
      question: 'Do you work with startups?',
      answer: 'Absolutely! We help startups build MVPs (Minimum Viable Products) to test their ideas quickly and affordably.',
    },
    {
      keywords: ['government', 'ngo', 'non-profit', 'organization'],
      question: 'Do you work with NGOs or government bodies?',
      answer: 'Yes, we develop data collection tools, reporting systems, and public-facing portals for organizations.',
    },

    // --- TECHNICAL & DESIGN DETAILS ---
    {
      keywords: ['mobile', 'android', 'ios', 'iphone', 'app'],
      question: 'Do you develop for both Android and iOS?',
      answer: 'Yes, we use cross-platform technologies like Flutter and React Native to ensure your app works on both platforms.',
    },
    {
      keywords: ['ui', 'ux', 'user interface', 'experience', 'wireframe'],
      question: 'What is your UI/UX design process?',
      answer: 'We start with wireframes and prototypes to ensure the app is intuitive and user-friendly before coding begins.',
    },
    {
      keywords: ['api', 'documentation', 'endpoints', 'third party'],
      question: 'Do you build custom APIs?',
      answer: 'Yes, we build robust, secure, and well-documented APIs for your web or mobile applications.',
    },
    {
      keywords: ['database', 'sql', 'mongodb', 'postgres', 'storage'],
      question: 'What databases do you use?',
      answer: 'We choose the best fit for your needs, typically PostgreSQL, MySQL, or MongoDB for high performance.',
    },
    {
      keywords: ['bug', 'error', 'fix', 'broken', 'issue'],
      question: 'What happens if I find a bug after launch?',
      answer: 'We offer a post-launch warranty period where we fix any bugs or technical issues for free.',
    },
    {
      keywords: ['source code', 'ownership', 'rights', 'github'],
      question: 'Who owns the source code?',
      answer: 'Once the project is fully paid for, you own 100% of the source code and intellectual property.',
    },
    {
      keywords: ['cloud', 'aws', 'azure', 'google cloud', 'vps'],
      question: 'Which cloud providers do you use?',
      answer: 'We work with AWS, Google Cloud, DigitalOcean, and local Ethiopian hosting providers depending on your needs.',
    },
    {
      keywords: ['speed', 'performance', 'slow', 'optimization'],
      question: 'Can you improve my existing website speed?',
      answer: 'Yes, we provide performance audits and optimization services to make your site lightning fast.',
    },
    {
      keywords: ['responsive', 'tablet', 'mobile view', 'screen size'],
      question: 'Will my website work on mobile phones?',
      answer: 'Yes, all our websites are fully responsive and look great on desktops, tablets, and smartphones.',
    },
    {
      keywords: ['dark mode', 'theme', 'customization'],
      question: 'Do you support dark mode in your apps?',
      answer: 'Yes, we can implement dynamic themes including dark and light modes for any application.',
    },

    // --- PRICING & CONTRACTS ---
    {
      keywords: ['hourly', 'fixed price', 'contract', 'payment plan'],
      question: 'What are your payment terms?',
      answer: 'We usually work with a milestone-based payment plan (e.g., 30% upfront, 40% mid-project, 30% on completion).',
    },
    {
      keywords: ['discount', 'cheap', 'cheaper', 'negotiate'],
      question: 'Do you offer discounts for small businesses?',
      answer: 'We provide competitive pricing and can scale project scope to fit your specific budget.',
    },
    {
      keywords: ['hidden fees', 'extra cost', 'surprise'],
      question: 'Are there any hidden costs?',
      answer: 'No. Our quotes are transparent and cover everything discussed in the project scope.',
    },
    {
      keywords: ['refund', 'money back', 'cancel'],
      question: 'What is your cancellation policy?',
      answer: 'You can cancel at any milestone. You only pay for the work completed up to that point.',
    },
    {
      keywords: ['invoice', 'receipt', 'tax', 'vat'],
      question: 'Do you provide formal invoices and VAT receipts?',
      answer: 'Yes, as a registered Ethiopian firm, we provide legal invoices and handle VAT where applicable.',
    },

    // --- SECURITY & LEGAL ---
    {
      keywords: ['nda', 'confidential', 'secret', 'privacy'],
      question: 'Will you sign an NDA?',
      answer: 'Absolutely. We respect your privacy and are happy to sign a Non-Disclosure Agreement before any discussion.',
    },
    {
      keywords: ['hacking', 'firewall', 'ssl', 'data breach'],
      question: 'How do you prevent hacking?',
      answer: 'We use SSL encryption, secure authentication, and regular security patches to protect your data.',
    },
    {
      keywords: ['backup', 'data loss', 'recovery'],
      question: 'Do you provide data backups?',
      answer: 'Yes, we set up automated daily or weekly backups to ensure your data is never lost.',
    },
    {
      keywords: ['compliance', 'gdpr', 'data law'],
      question: 'Is your software compliant with data laws?',
      answer: 'We follow best practices for data privacy, ensuring compliance with local and international standards.',
    },

    // --- CLIENT INTERACTION & SUPPORT ---
    {
      keywords: ['meeting', 'zoom', 'google meet', 'talk'],
      question: 'Can we have a video call?',
      answer: 'Yes! we can schedule a Zoom or Google Meet call at your convenience.',
    },
    {
      keywords: ['language', 'english', 'communication'],
      question: 'Can we communicate in English?',
      answer: 'Yes, our team is fluent in both Amharic and English for seamless communication.',
    },
    {
      keywords: ['training', 'how to use', 'staff training'],
      question: 'Do you train my staff on the new system?',
      answer: 'Yes, we provide hands-on training sessions and video tutorials for your team.',
    },
    {
      keywords: ['update', 'progress report', 'status'],
      question: 'How often will I get updates?',
      answer: 'We usually provide weekly updates and demo sessions to show you the progress.',
    },
    {
      keywords: ['urgency', 'fast', 'quick delivery', 'rushed'],
      question: 'Can you handle urgent projects?',
      answer: 'Yes, for urgent needs, we can allocate more resources to meet tight deadlines.',
    },

    // --- MARKETING & GROWTH ---
    {
      keywords: ['content', 'writing', 'copywriting', 'blog'],
      question: 'Do you write content for websites?',
      answer: 'Yes, we offer professional copywriting services to help tell your brand story effectively.',
    },
    {
      keywords: ['email', 'newsletter', 'marketing'],
      question: 'Do you set up email marketing?',
      answer: 'Yes, we can integrate Mailchimp or other providers to help you send newsletters to your customers.',
    },
    {
      keywords: ['domain', 'name', 'register'],
      question: 'Can you help me buy a domain name?',
      answer: 'Yes, we assist in finding and registering the perfect .com, .et, or .org domain for you.',
    },
    {
      keywords: ['google maps', 'location', 'seo'],
      question: 'Can you put my business on Google Maps?',
      answer: 'Yes, we provide Google Business Profile setup as part of our SEO and digital marketing package.',
    },
    {
      keywords: ['sms', 'bulk sms', 'notification'],
      question: 'Do you provide bulk SMS services?',
      answer: 'Yes, we integrate SMS gateways so your system can send automated notifications to Ethiopian phone numbers.',
    },

    // --- MISCELLANEOUS / FUN ---
    {
      keywords: ['internship', 'job', 'career', 'work here'],
      question: 'Are you hiring or offering internships?',
      answer: 'We are always looking for talent! Please send your CV to our official email for consideration.',
    },
    {
      keywords: ['vision', 'mission', 'why choose you'],
      question: 'What is FortinoTech’s mission?',
      answer: 'Our mission is to empower Ethiopian businesses through world-class, localized digital solutions.',
    },
    {
      keywords: ['ai', 'chatgpt', 'bot', 'chatbot'],
      question: 'Can you build an AI chatbot for me?',
      answer: 'Yes, we develop custom AI-powered chatbots for customer service and automated sales.',
    },
    {
      keywords: ['coffee', 'bunna', 'office visit'],
      question: 'Can I come over for coffee and a talk?',
      answer: 'Of course! We love discussing tech over a cup of Ethiopian coffee at our Addis office.',
    },
    {
      keywords: ['graphic', 'flyer', 'poster', 'social media post'],
      question: 'Do you design social media posts?',
      answer: 'Yes, our graphics team creates engaging posters, flyers, and social media content.',
    },
    {
      keywords: ['mobile money', 'wallet', 'fintech'],
      question: 'Can you build a mobile wallet app?',
      answer: 'Yes, we have experience building secure fintech wallets with transaction histories and QR payments.',
    },
    {
      keywords: ['erp', 'enterprise', 'resource planning'],
      question: 'Do you offer ERP systems?',
      answer: 'Yes, we build custom ERPs to manage HR, Finance, and Operations in one place.',
    },
    {
      keywords: ['cloud storage', 'google drive', 'dropbox integration'],
      question: 'Can you integrate cloud storage?',
      answer: 'Yes, we can connect your app to Google Drive, Dropbox, or S3 for file management.',
    },
    {
      keywords: ['multilingual', 'multiple languages', 'translate'],
      question: 'Can my site be in three languages?',
      answer: 'Yes, we support multi-language setups (e.g., Amharic, Oromiffa, and English) on a single site.',
    },
    {
      keywords: ['maintenance cost', 'monthly fee'],
      question: 'Is there a monthly maintenance fee?',
      answer: 'We offer flexible maintenance plans—monthly, yearly, or pay-as-you-go for updates.',
    },
    {
      keywords: ['consultation', 'advice', 'strategy'],
      question: 'Do you provide free consultations?',
      answer: 'The first consultation is always free! We want to understand your vision first.',
    },
    {
      keywords: ['custom software', 'special', 'unique'],
      question: 'Can you build something that has never been done?',
      answer: 'We love challenges! If you can dream it, our engineering team can build it.',
    },
    {
      keywords: ['offline app', 'no data', 'sync'],
      question: 'How do offline apps work?',
      answer: 'Data is saved locally on the device and automatically syncs to the server once internet is available.',
    },
    {
      keywords: ['payment security', 'pci'],
      question: 'Is my customers payment data safe?',
      answer: 'Yes, we use encrypted gateways and never store sensitive credit card or PIN info on our servers.',
    },
    {
      keywords: ['open source', 'wordpress', 'custom code'],
      question: 'Do you use WordPress or custom code?',
      answer: 'We do both! We use WordPress for simple sites and custom React/Node.js for complex applications.',
    },
    {
      keywords: ['api integration', 'connect apps'],
      question: 'Can you connect my website to my Telegram bot?',
      answer: 'Yes, we can sync your website data with a Telegram bot for easy notifications and management.',
    },
    {
      keywords: ['video', 'editing', 'animation'],
      question: 'Do you do video editing or motion graphics?',
      answer: 'Yes, we provide motion graphics and short promotional video services for your products.',
    },
    {
      keywords: ['e-commerce shipping', 'delivery fee'],
      question: 'Can the store calculate delivery fees automatically?',
      answer: 'Yes, we can set up location-based delivery fee calculations for Addis Ababa and other regions.',
    },
    {
      keywords: ['user roles', 'admin', 'editor', 'permissions'],
      question: 'Can I have different admin levels?',
      answer: 'Yes, we build Role-Based Access Control (RBAC) so you can control what each staff member sees.',
    },
    {
      keywords: ['testing', 'qa', 'quality assurance'],
      question: 'How do you test the software?',
      answer: 'We perform manual testing, automated unit tests, and user acceptance testing (UAT) before launch.',
    },
    {
      keywords: ['redesign', 'old site', 'makeover'],
      question: 'Can you redesign my old website?',
      answer: 'Yes, we can give your existing site a modern, professional look while keeping your data intact.',
    },
    {
      keywords: ['seo audit', 'rank higher'],
      question: 'Why is my site not on Google?',
      answer: 'It might lack SEO. We can perform an audit and optimize your site to improve its ranking.',
    },
    {
      keywords: ['it audit', 'security check'],
      question: 'Do you provide IT security audits?',
      answer: 'Yes, we analyze your current systems for vulnerabilities and provide a detailed security report.',
    },
    {
      keywords: ['hardware', 'computer', 'server purchase'],
      question: 'Do you sell computers or servers?',
      answer: 'We focus on software, but we can advise you on what hardware to buy and help with the setup.',
    },
    {
      keywords: ['remote', 'online', 'distance'],
      question: 'Can we work together if I am outside Ethiopia?',
      answer: 'Yes, we have many international clients. We use Slack, Zoom, and Trello for remote collaboration.',
    },
    {
      keywords: ['contract length', 'long term'],
      question: 'Do you do long-term partnerships?',
      answer: 'Yes, we act as a dedicated tech partner for many firms, providing ongoing development for years.',
    },
    {
      keywords: ['bug bounty', 'security report'],
      question: 'Do you have a bug bounty program?',
      answer: 'We appreciate security researchers! Please contact us directly to report any vulnerabilities.',
    },
    {
      keywords: ['app store', 'play store', 'publishing'],
      question: 'Will you upload my app to the stores?',
      answer: 'Yes, we handle the entire submission process for the Apple App Store and Google Play Store.',
    },
    {
      keywords: ['referral', 'commission', 'partner'],
      question: 'Do you have a referral program?',
      answer: 'Yes, we offer commissions or discounts for clients who refer new projects to us.',
    },
    {
      keywords: ['data migration', 'excel to web'],
      question: 'Can you move my Excel data to a new system?',
      answer: 'Yes, we specialize in migrating data from old spreadsheets or legacy systems into modern databases.',
    },
    {
      keywords: ['biometrics', 'fingerprint', 'face id'],
      question: 'Do you support biometric integration?',
      answer: 'Yes, we can integrate fingerprint and facial recognition for high-security applications.',
    },
    {
      keywords: ['qr code', 'scanner'],
      question: 'Can you build a QR-based system?',
      answer: 'Yes, we build QR systems for ticketing, payments, and product authentication.',
    },
    {
      keywords: ['iot', 'sensors', 'smart'],
      question: 'Do you work with IoT or smart devices?',
      answer: 'We can build software that connects to IoT devices for monitoring and data visualization.',
    },
    {
      keywords: ['printing', 'invoice print', 'pos printer'],
      question: 'Does your system support thermal printers?',
      answer: 'Yes, our POS and billing systems are compatible with standard thermal and network printers.',
    },
    {
      keywords: ['legal advice', 'software law'],
      question: 'Do you help with software copyrights?',
      answer: 'We can guide you on the steps to register your software at the Ethiopian Intellectual Property Office.',
    },
    {
      keywords: ['startup pitch', 'investor deck'],
      question: 'Can you help with technical pitch decks?',
      answer: 'Yes, we provide technical diagrams and prototypes to help you impress your investors.',
    },
    {
      keywords: ['analytics dashboard', 'stats'],
      question: 'Will I see how many people use my app?',
      answer: 'Yes, we integrate Google Analytics or custom dashboards so you can track user behavior.',
    },
    {
      keywords: ['hosting renewal', 'expired'],
      question: 'What happens when my hosting expires?',
      answer: 'We send you reminders 30 days in advance and help you with the renewal process.',
    },
    {
      keywords: ['email setup', 'business email', 'info@'],
      question: 'Can you create professional emails for my staff?',
      answer: 'Yes, we set up business emails (e.g., yourname@yourcompany.com) via Google Workspace or Outlook.',
    },
    {
      keywords: ['feedback', 'complaint', 'suggestion'],
      question: 'How do I provide feedback?',
      answer: 'We value your input! You can send feedback via our contact form or directly to your project manager.',
    },
    {
      keywords: ['outsource', 'white label'],
      question: 'Do you do white-label development?',
      answer: 'Yes, we can build software for your agency to sell under your own brand name.',
    },
    {
      keywords: ['tech stack', 'why react'],
      question: 'Why do you use React?',
      answer: 'We use React because it is fast, scalable, and supported by a massive community, ensuring your site stays modern.',
    },
    {
      keywords: ['pwa', 'progressive web app'],
      question: 'Do you build PWAs?',
      answer: 'Yes, we build Progressive Web Apps that can be installed on phones like a regular app but run via the web.',
    },
    {
      keywords: ['crm', 'customer management'],
      question: 'Do you build CRM systems?',
      answer: 'Yes, we build custom CRMs to help you track leads, customers, and sales pipelines.',
    },
    {
      keywords: ['real time', 'chat', 'socket'],
      question: 'Can you build a real-time chat app?',
      answer: 'Yes, we use WebSockets to build instant messaging and real-time collaboration tools.',
    },
    {
      keywords: ['adwords', 'ppc', 'paid ads'],
      question: 'Do you manage Google Ads?',
      answer: 'Yes, we run targeted PPC campaigns to get your business to the top of search results immediately.',
    },
    {
      keywords: ['maintenance manual', 'admin guide'],
      question: 'Do I get a manual for the system?',
      answer: 'Yes, we provide a detailed PDF or video guide on how to manage your new system.',
    },
    {
      keywords: ['server migration'],
      question: 'Can you move my site to a different server?',
      answer: 'Yes, we provide safe and zero-downtime migration services for websites and databases.',
    },
    {
      keywords: ['captcha', 'spam'],
      question: 'How do you stop spam on my contact form?',
      answer: 'We implement Google reCAPTCHA and advanced filtering to keep your inbox clean from bots.',
    },
    {
      keywords: ['font', 'typography', 'custom font'],
      question: 'Can you use a custom brand font?',
      answer: 'Yes, we can integrate any custom web-font to match your branding perfectly.',
    },
    {
      keywords: ['dark web', 'leaked data', 'scan'],
      question: 'Do you check if my company data is leaked?',
      answer: 'We can perform basic data leak checks as part of our initial security consultation.',
    },
    {
      keywords: ['zoom training', 'remote session'],
      question: 'Do you offer remote training?',
      answer: 'Yes, we conduct screen-sharing sessions to teach your team how to use the software from anywhere.',
    },
    {
      keywords: ['holiday', 'working hours'],
      question: 'Do you work on weekends?',
      answer: 'Our standard hours are Monday-Friday, but we provide 24/7 support for emergency technical issues.',
    },
    {
      keywords: ['speed dial', 'fast contact'],
      question: 'What is the fastest way to reach you?',
      answer: 'Our Telegram channel or direct phone line is the fastest way for immediate communication.',
    },
    {
      keywords: ['tech debt', 'clean code'],
      question: 'Do you follow clean code standards?',
      answer: 'Always. We follow SOLID principles and industry standards to ensure the code is easy to maintain.',
    },
    {
      keywords: ['prototype speed', 'how fast mockup'],
      question: 'How fast can I see a prototype?',
      answer: 'We can usually deliver a basic clickable wireframe or UI mockup within 3-5 business days.',
    },
    {
      keywords: ['success', 'guarantee'],
      question: 'Do you guarantee project success?',
      answer: 'We guarantee technical excellence and that the final product will match the agreed-upon requirements.',
    },
    {
      keywords: ['thank you', 'awesome', 'cool'],
      question: 'I love your work!',
      answer: 'Thank you so much! We love building great things for our clients. ',
    },
    {
      keywords: ['what is fortino', 'name meaning','fortino'],
      question: 'What does the name Fortino mean?',
      answer: 'Fortino stands for strength and fortification—representing the robust and secure tech we build.',
    },
    {
      keywords: ['future tech', 'ar', 'vr'],
      question: 'Do you work with AR or VR?',
      answer: 'We are currently exploring AR/VR solutions—feel free to discuss your experimental ideas with us!',
    }
  ],
  am: [
    
      {
        keywords: ['አገልግሎቶች', 'ትሰጣላችሁ', 'መስጠት', 'አገልግሎት'],
        question: 'ምን አይነት አገልግሎቶችን ታቀርባላችሁ?',
        answer: 'የድረ-ገጽ ልማት፣ የሞባይል መተግበሪያ ልማት፣ የግራፊክስ ዲዛይን፣ ዲጂታል ማርኬቲንግ እና የአይቲ አማካሪ አገልግሎቶችን እንሰጣለን።',
      },
      {
        keywords: ['ጊዜ', 'ቆይታ', 'ምን ያህል', 'ፕሮጀክት', 'ጊዜ ሰሌዳ'],
        question: 'አንድ ፕሮጀክት ምን ያህል ጊዜ ይወስዳል?',
        answer: 'የፕሮጀክት የጊዜ ሰሌዳ እንደ ስራው ስፋት እና ውስብስብነት ይወሰናል። ሙሉ ግምገማ ካደረግን በኋላ ግልጽ የሆነ የጊዜ ሰሌዳ እንሰጣለን።',
      },
      {
        keywords: ['ድጋፍ', 'በኋላ', 'ማጠናቀቅ', 'ጥገና', 'እርዳታ', 'እገዛ'],
        question: 'ስራው ከተጠናቀቀ በኋላ ድጋፍ ትሰጣላችሁ?',
        answer: 'አዎ! ለሁሉም ደንበኞቻችን የ24/7 የቴክኒክ ድጋፍ እና የጥገና አገልግሎት እንሰጣለን።',
      },
      {
        keywords: ['ቴክኖሎጂ', 'ቴክ', 'መሳሪያዎች', 'ቋንቋዎች'],
        question: 'ምን አይነት ቴክኖሎጂዎችን ትጠቀማላችሁ?',
        answer: 'ዘመናዊ የሆኑትን React, Node.js, Python, TypeScript እና ሌሎች አለምአቀፍ ደረጃቸውን የጠበቁ መሳሪያዎችን እንጠቀማለን።',
      },
      {
        keywords: ['ማገናኘት', 'ያለ', 'ሲስተም', 'መስራት', 'ተስማሚ'],
        question: 'ከነባር ሲስተሞች ጋር ማገናኘት ትችላላችሁ?',
        answer: 'በፍጹም! ከማንኛውም ነባር ሲስተም ጋር የማቀናጀት (Integration) አገልግሎት እንሰጣለን።',
      },
      {
        keywords: ['ዋጋ', 'ክፍያ', 'ሂሳብ', 'ውድ'],
        question: 'የዋጋ አማራጮቻችሁ ምንድን ናቸው?',
        answer: 'ዋጋው እንደ ፕሮጀክቱ ፍላጎት ይወሰናል። ምክንያታዊ የሆነ ዋጋ እና የጊዜ ሰሌዳ እናቀርባለን - ለዝርዝሩ ያግኙን።',
      },
      {
        keywords: ['ጥገና', 'ማሻሻያ', 'ክትትል', 'ድጋፍ'],
        question: 'የጥገና አገልግሎት ትሰጣላችሁ?',
        answer: 'አዎ! ቀጣይነት ያለው ጥገና፣ ወቅታዊ ማሻሻያዎችን እና ክትትል እናደርጋለን።',
      },
      {
        keywords: ['ሂደት', 'አሰራር', 'እንዴት', 'ደረጃዎች', 'መንገድ'],
        question: 'የልማት ሂደታችሁ እንዴት ነው?',
        answer: 'ቀልጣፋ የሆነውን Agile የአሰራር ዘዴ እንጠቀማለን - ይህም ቀጥታ ግንኙነትን፣ መደበኛ ወቅታዊ መረጃዎችን እና የግምገማ ስራዎችን ያካትታል።',
      },
      {
        keywords: ['hosting', 'መልቀቅ', 'ሰርቨር', 'ድረገጽ', 'deploy'],
        question: 'በሆስቲንግ እና በዲፕሎይመንት በኩል ትረዳላችሁ?',
        answer: 'አዎ! ሙሉ የሆስቲንግ እና የዲፕሎይመንት ድጋፍ እንሰጣለን።',
      },
      {
        keywords: ['መጀመር', 'መገናኘት', 'መቅጠር', 'መስራት'],
        question: 'እንዴት መጀመር እችላለሁ?',
        answer: 'በጣም ቀላል! በድረ-ገጻችን የግንኙነት ፎርም፣ በWhatsApp (+251 979 235 206) ወይም በTelegram (@fortinotech) ያግኙን።',
      },
      {
        keywords: ['whatsapp', 'telegram', 'ቀጥታ', 'ውይይት', 'መልእክት', 'ሰው'],
        question: 'ከቡድናችሁ ጋር በቀጥታ እንዴት እነጋገራለሁ?',
        answer: 'ከቡድናችን ጋር በቀጥታ በWhatsApp (+251 979 235 206) ወይም በTelegram (@fortinotech) መነጋገር ይችላሉ። በዚህ የውይይት መስኮት ውስጥ ያሉትን የWhatsApp እና Telegram አዝራሮች ይጠቀሙ።',
      },
      {
        keywords: ['ሰላም', 'ሄሎ', 'ጤና ይስጥልኝ'],
        question: 'ሰላምታ',
        answer: 'ሰላም!  ዛሬ በምን ላግዝዎት እችላለሁ?',
      },
      {
        keywords: ['እንደምን አደሩ', 'ጥዋት'],
        question: 'የጥዋት ሰላምታ',
        answer: 'እንደምን አደሩ!  ስለ ፕሮጀክትዎ ለመወያየት ዝግጁ ነዎት?',
      },
      {
        keywords: ['እንደምን ዋሉ', 'ከሰአት'],
        question: 'የከሰአት ሰላምታ',
        answer: 'እንደምን ዋሉ! ዛሬ እንዴት ልረዳዎት እችላለሁ?',
      },
      {
        keywords: ['እንደምን አመሹ', 'ማታ'],
        question: 'የምሽት ሰላምታ',
        answer: 'እንደምን አመሹ!  በፕሮጀክት ጉዳይ እርዳታ ይፈልጋሉ?',
      },
      {
        keywords: ['አመሰግናለሁ', 'ምስጋና'],
        question: 'ምስጋና',
        answer: 'ምንም አይደለም!  ሌላ የምረዳዎት ነገር አለ?',
      },
      {
        keywords: ['ደህና ሁኑ', 'ቻው', 'በኋላ እንገናኝ'],
        question: 'መሰናበቻ',
        answer: 'ደህና ሁኑ! መልካም ቀን ይሁንልዎ፤ በፈለጉት ጊዜ እኛን ማግኘት ይችላሉ።',
      },
      {
        keywords: ['ቀልድ', 'አስቂኝ', 'ሳቅ'],
        question: 'ቀልድ ንገረኝ',
        answer: "ለምንድነው አንድ ሶፍትዌር ዴቨሎፐር የደኸየው? 'Cache' (ካሽ/ጥሬ ገንዘብ) ስለጨረሰ! ",
      },
      {
        keywords: ['ፖርትፎሊዮ', 'ስራዎች', 'የተሰሩ ስራዎች'],
        question: 'የተሰሩ ስራዎች (Portfolio)',
        answer: 'እስካሁን ያጠናቀቅናቸውን ፕሮጀክቶች ለማየት በድረ-ገጻችን ላይ ያለውን የፖርትፎሊዮ ክፍል መመልከት ይችላሉ።',
      },
      {
        keywords: ['ምስክርነት', 'አስተያየት', 'ደንበኞች'],
        question: 'የደንበኞች አስተያየት',
        answer: 'አዎ! ደንበኞቻችን ስለ እኛ ምን እንደሚሉ ለማየት ምስክርነት (Testimonials) የሚለውን ክፍል ይመልከቱ።',
      },
      {
        keywords: ['ስልጠና', 'መመሪያ', 'እርዳታ'],
        question: 'ስልጠና እና ሰነዶች',
        answer: 'ሲስተምዎን በቀላሉ ማስተዳደር እንዲችሉ ስልጠናዎችን እና የተሟላ መመሪያ (Documentation) እናቀርባለን።',
      },
      {
        keywords: ['አደጋ', 'አስቸኳይ', 'ድጋፍ'],
        question: 'የአስቸኳይ ጊዜ ድጋፍ',
        answer: 'ለአስቸኳይ እና ወሳኝ ችግሮች በማንኛውም ሰዓት ፈጣን ድጋፍ እንሰጣለን።',
      },
      {
        keywords: ['ልዩ', 'የተበጀ', 'የግል'],
        question: 'የተበጁ መፍትሄዎች',
        answer: 'ለእርስዎ ልዩ የንግድ ፍላጎት የሚስማሙ የተበጁ መፍትሄዎችን እንፈጥራለን።',
      },
      {
        keywords: ['ሊያድግ የሚችል', 'እድገት', 'መስፋፋት'],
        question: 'ሊያድጉ የሚችሉ ሲስተሞች',
        answer: 'የምንሰራቸው ሲስተሞች ከንግድዎ እድገት ጋር አብረው እንዲያድጉ (Scalable) ተደርገው የተገነቡ ናቸው።',
      },
      {
        keywords: ['ደህንነት', 'ጥበቃ', 'አስተማማኝ', 'ሴኩሪቲ'],
        question: 'ደህንነት',
        answer: 'የእርስዎ ፕሮጀክት ደህንነቱ የተጠበቀ እንዲሆን አስተማማኝ የጥበቃ እርምጃዎችን እንጠቀማለን።',
      },
      {
        keywords: ['አናሊቲክስ', 'ሪፖርት', 'ዳታ'],
        question: 'አናሊቲክስ',
        answer: 'የፕሮጀክትዎን አፈጻጸም ለመከታተል እና ለማሻሻል የሚያስችሉ የአናሊቲክስ መመሪያዎችን እናቀርባለን።',
      },
      {
        keywords: ['ኢኮሜርስ', 'ሱቅ', 'ሽያጭ', 'ኦንላይን'],
        question: 'የኢኮሜርስ መፍትሄዎች',
        answer: 'ደህንነቱ የተጠበቀ የክፍያ ስርዓት ያለው እና ለተጠቃሚ ምቹ የሆነ የኦንላይን መገበያያ ሱቆችን እንገነባለን።',
      },
      {
        keywords: ['ብራንዲንግ', 'ሎጎ', 'መታወቂያ'],
        question: 'ብራንዲንግ',
        answer: 'ሎጎዎችን እና የተለያዩ የግራፊክስ ስራዎችን በመስራት ጠንካራ የንግድ መታወቂያ እንዲኖርዎት እንረዳለን።',
      },
      {
        keywords: ['ሶሻል ሚዲያ', 'ፌስቡክ', 'ማስታወቂያ'],
        question: 'የሶሻል ሚዲያ ማርኬቲንግ',
        answer: 'የብራንድዎ ታዋቂነት እንዲጨምር የሶሻል ሚዲያ ዘመቻዎችን እናስተዳድራለን።',
      },
      {
        keywords: ['seo', 'ጎግል', 'ደረጃ'],
        question: 'SEO',
        answer: 'ድረ-ገጽዎ በጎግል ፍለጋ ላይ ቀዳሚ ደረጃ እንዲይዝ እና ብዙ ሰው እንዲጎበኘው እናደርጋለን።',
      },
      {
        keywords: ['ማስታወቂያ', 'ዘመቻ', 'ማስተዋወቅ'],
        question: 'ማስታወቂያ',
        answer: 'ለንግድዎ ሽያጭን እና ደንበኛን የሚያመጡ የማስታወቂያ ዘመቻዎችን እንሰራለን።',
      },
      {
        keywords: ['እንዴት', 'መጀመር', 'መገናኘት', 'መቅጠር'],
        question: 'እንዴት መጀመር ይቻላል?',
        answer: 'በጣም ቀላል! በኢሜል፣ በፌስቡክ ወይም በግንኙነት ፎርማችን በኩል ያግኙን።',
      },
      {
        keywords: ['አሰራር', 'ሂደት', 'ደረጃዎች'],
        question: 'የልማት ሂደት',
        answer: 'Agile የአሰራር ዘዴን በመከተል በየደረጃው መደበኛ መረጃዎችን ለደንበኞቻችን እናደርሳለን።',
      },
      {
        keywords: ['ማሻሻያ', 'ክትትል', 'ጥገና'],
        question: 'የማያቋርጥ ድጋፍ',
        answer: 'አዎ! ለሁሉም ስራዎቻችን የማያቋርጥ ጥገና፣ ማሻሻያ እና የክትትል ድጋፍ እንሰጣለን።',
      },
      {
        keywords: ['ጊዜ', 'ቆይታ', 'ቀጠሮ'],
        question: 'የፕሮጀክት የጊዜ ሰሌዳ',
        answer: 'የጊዜ ሰሌዳው እንደ ስራው ክብደት ይወሰናል፤ ዝርዝር እቅዱን ከግምገማ በኋላ እናሳውቃለን።',
      },
      {
        keywords: ['መሳሪያዎች', 'ሶፍትዌር', 'ቴክኖሎጂ'],
        question: 'ጥቅም ላይ የዋሉ ቴክኖሎጂዎች',
        answer: 'እንደ React, Node.js, Python እና TypeScript ያሉ ዘመናዊ ቴክኖሎጂዎችን እንጠቀማለን።',
      },
      {
        keywords: ['ማገናኘት', 'መቀናጀት', 'ነባር ሲስተም'],
        question: 'የሲስተም ውህደት',
        answer: 'በእርግጥ! ካሉዎት ነባር ሲስተሞች ጋር ያለምንም ችግር ማገናኘት እንችላለን።',
      },
      {
        keywords: ['መልቀቅ', 'ሆስቲንግ', 'ሰርቨር'],
        question: 'ሆስቲንግ እና ዲፕሎይመንት',
        answer: 'ሙሉ የሰርቨር ዝግጅት፣ ሆስቲንግ እና ሲስተሙን የማልቀቅ (Deployment) ስራ እንሰራለን።',
      },
      {
        keywords: ['ክፍያ', 'ቴሌቢር', 'ሲቢኢ', 'ባንክ', 'አገናኝ'],
        question: 'የሀገር ውስጥ የክፍያ አማራጮችን (Payment Gateways) ታገናኛላችሁ?',
        answer: 'አዎ! ቴሌቢርን (telebirr)፣ ሲቢኢ ብርን፣ ቻፓን እና ሌሎች የባንክ ሲስተሞችን ከድረ-ገጽዎ ወይም ከሞባይል መተግበሪያዎ ጋር እናገናኛለን።',
      },
      {
        keywords: ['ቢሮ', 'አድራሻ', 'አዲስ አበባ', 'የት ነው', 'ቦታ'],
        question: 'ቢሮአችሁ የት ነው የሚገኘው?',
        answer: 'ቢሮአችን አዲስ አበባ፣ ጀሞ ሚካኤል፣ ፒዮኒ ኮመርሻል ቪልዲንግ፣ ቢሮ ቁጥር 306/A ይገኛል። ለምክክር መጥተው ማግኘት ይችላሉ።',
      },
      {
        keywords: ['cctv', 'ካሜራ', 'ደህንነት', 'ክትትል'],
        question: 'የCCTV ካሜራ ትከላላችሁ?',
        answer: 'አዎ። ለቤት፣ ቢሮ፣ ክሊኒክ እና የንግድ ሕንፃዎች የCCTV ተከላ፣ ማስተካከያ እና ከስልክ የርቀት እይታ እንሰጣለን።',
      },
      {
        keywords: ['ድረ-ገጽ', 'ዌብሳይት', 'ድህረ ገጽ'],
        question: 'ለንግዴ ድረ-ገጽ ትሰራላችሁ?',
        answer: 'አዎ። የኩባንያ፣ የክሊኒክ፣ የኦንላይን ሱቅ እና ሌሎች ድረ-ገጾችን ከሆስቲንግ እና ጥገና ጋር እንገነባለን።',
      },
      {
        keywords: ['ቋንቋ', 'አማርኛ', 'ኦሮምኛ', 'አካባቢያዊ'],
        question: 'በአማርኛ እና በሌሎች የአገር ውስጥ ቋንቋዎች የሚሰሩ ሲስተሞችን ትሰራላችሁ?',
        answer: 'አዎ፣ ሲስተሞቻችን ለተጠቃሚዎች ምቹ እንዲሆኑ በአማርኛ፣ በኦሮምኛ እና በሌሎች የአገር ውስጥ ቋንቋዎች ተበጅተው ሊሰሩ ይችላሉ።',
      },
      {
        keywords: ['ኢንተርኔት', 'ኦፍላይን', 'ኔትወርክ', 'የለም'],
        question: 'ኢንተርኔት በሌለበት ሁኔታ የሚሰሩ ሲስተሞችን ትሰራላችሁ?',
        answer: 'አዎ፣ የኢንተርኔት መቆራረጥ ስራዎን እንዳያስተጓጉል "Offline-first" የሆኑ ወይም በውስጥ መስመር (Local Network) የሚሰሩ ሶፍትዌሮችን እንሰራለን።',
      },
      {
        keywords: ['ህጋዊ', 'ፈቃድ', 'ንግድ', 'ፎርቲኖቴክ'],
        question: 'ፎርቲኖቴክ ህጋዊ የንግድ ፈቃድ ያለው ድርጅት ነው?',
        answer: 'አዎ፣ ፎርቲኖቴክ በአዲስ አበባ ኢትዮጵያ በህግ ተመዝግቦ እና የንግድ ፈቃድ አውጥቶ የሚንቀሳቀስ የአይቲ ተቋም ነው።',
      },
      {
        keywords: ['ሆስፒታል', 'ክሊኒክ', 'ህክምና', 'ጤና', 'ታካሚ'],
        question: 'የጤና ተቋማት ሶፍትዌር ትሰራላችሁ?',
        answer: 'አዎ! የሆስፒታል ማኔጅመንት ሲስተም (HMS)፣ የታካሚዎች መዝገብ መከታተያ እና የመድኃኒት ቤት መቆጣጠሪያ መተግበሪያዎችን እንሰራለን።',
      },
      {
        keywords: ['ትምህርት ቤት', 'ዩኒቨርሲቲ', 'ተማሪ', 'ትምህርት', 'ኢ-ለርኒንግ'],
        question: 'የትምህርት መድረኮችን ትገነባላችሁ?',
        answer: 'የተማሪዎች መቆጣጠሪያ ሲስተም (LMS)፣ የተማሪዎች ፖርታል እና የትምህርት ቤት አስተዳደር ሶፍትዌሮችን እንፈጥራለን።',
      },
      {
        keywords: ['ሆቴል', 'ቡኪንግ', 'ቦታ መያዣ', 'ቱሪዝም'],
        question: 'የሆቴል ቦታ መያዣ (Booking System) መስራት ትችላላችሁ?',
        answer: 'በእርግጠኝነት። ወቅታዊ ክፍት ቦታዎችን የሚያሳይ እና ከሀገር ውስጥ የክፍያ አማራጮች ጋር የተገናኘ የቦታ መያዣ ሲስተም እንሰራለን።',
      },
      {
        keywords: ['ሪል ስቴት', 'ቤት', 'ኪራይ', 'ሽያጭ', 'መሬት'],
        question: 'ለሪል ስቴት ስራዎች መፍትሄዎች አላችሁ?',
        answer: 'አዎ፣ ከካርታ ጋር የተገናኙ የቤት ማስታወቂያ መድረኮችን እና ለደላሎች የሚሆን የደንበኞች መከታተያ ሲስተም እንገነባለን።',
      },
      {
        keywords: ['ዴሊቨሪ', 'ሎጂስቲክስ', 'ትራኪንግ', 'ፖስታ', 'ጭነት'],
        question: 'የዕቃ ማድረሻ (Delivery) መተግበሪያዎችን ትሰራላችሁ?',
        answer: 'የሾፌሮች መቆጣጠሪያ መተግበሪያ፣ የጂፒኤስ (GPS) መከታተያ እና የትዕዛዝ ማስተዳደሪያ ዳሽቦርዶችን ያካተተ የሎጂስቲክስ ሶፍትዌር እንሰራለን።',
      },
      {
        keywords: ['ሬስቶራንት', 'ሜኑ', 'ምግብ', 'ትዕዛዝ'],
        question: 'የሬስቶራንት ማኔጅመንት ሲስተም ትሰጣላችሁ?',
        answer: 'አዎ፣ ዲጂታል ሜኑ፣ የኦንላይን ማዘዣ ሲስተም እና የሽያጭ መመዝገቢያ (POS) አገልግሎት እንሰጣለን።',
      },
      {
        keywords: ['ማይክሮ ፋይናንስ', 'ባንክ', 'ሳኮ', 'እቁብ', 'ፋይናንስ'],
        question: 'ለእቁብ ወይም ለብድርና ቁጠባ (Sacco) ሲስተም ትሰራላችሁ?',
        answer: 'በፊንቴክ ዘርፍ ልዩ ልምድ አለን፤ የዲጂታል እቁብ መድረኮችን እና የብድርና ቁጠባ ማኔጅመንት ሶፍትዌሮችን ከቴሌብር ጋር አቀናጅተን እንሰራለን።',
      },
      {
        keywords: ['ኢንቬንተሪ', 'ክምችት', 'መጋዘን', 'ሱቅ መቆጣጠሪያ'],
        question: 'የንብረት ቁጥጥር (Inventory Management) ትሰራላችሁ?',
        answer: 'አዎ፣ የእኛ ሲስተሞች የክምችት መጠንን፣ ሽያጭን እና ትዕዛዞችን በቅጽበት ለመቆጣጠር ይረዱዎታል።',
      },
      {
        keywords: ['ስታርታፕ', 'ፕሮቶታይፕ', 'አዲስ ሃሳብ', 'ኤምቪፒ'],
        question: 'ከአዳዲስ ስታርታፖች ጋር ትሰራላችሁ?',
        answer: 'በጣም! ስታርታፖች ሃሳባቸውን በፍጥነት እና በዝቅተኛ ወጪ እንዲሞክሩ ኤምቪፒ (MVP) እንዲገነቡ እናግዛለን።',
      },
      {
        keywords: ['መንግስት', 'ኤንጂኦ', 'መህረድ', 'ድርጅት'],
        question: 'ከመንግስታዊ ካልሆኑ ድርጅቶች (NGOs) ወይም ከመንግስት መስሪያ ቤቶች ጋር ትሰራላችሁ?',
        answer: 'አዎ፣ የመረጃ መሰብሰቢያ መሳሪያዎችን፣ የሪፖርት ማቅረቢያ ሲስተሞችን እና የህዝብ አገልግሎት ድረ-ገጾችን እንገነባለን።',
      },
      {
        keywords: ['ሞባይል', 'አንድሮይድ', 'አይኦኤስ', 'አይፎን', 'አፕ'],
        question: 'ለአንድሮይድም ሆነ ለiOS ስልኮች አፕ ትሰራላችሁ?',
        answer: 'አዎ፣ እንደ Flutter እና React Native ያሉ ቴክኖሎጂዎችን በመጠቀም አፑ በሁለቱም የስልክ አይነቶች ላይ እንዲሰራ እናደርጋለን።',
      },
      {
        keywords: ['ዩአይ', 'ዩኤክስ', 'ዲዛይን', 'ተጠቃሚ'],
        question: 'የዲዛይን ሂደታችሁ ምን ይመስላል?',
        answer: 'ወደ ኮዲንግ ከመግባታችን በፊት የአፑ አጠቃቀም ቀላል መሆኑን ለማረጋገጥ የንድፍ ስዕሎችን (Wireframes) እና ቅድመ-እይታዎችን (Prototypes) እናዘጋጃለን።',
      },
      {
        keywords: ['ዳታቤዝ', 'ኤስኪውኤል', 'ሞንጎዲቢ', 'መረጃ ማከማቻ'],
        question: 'ምን አይነት ዳታቤዞችን ትጠቀማላችሁ?',
        answer: 'እንደ ፕሮጀክቱ አስፈላጊነት PostgreSQL፣ MySQL ወይም MongoDB የመሳሰሉ ፈጣን ዳታቤዞችን እንጠቀማለን።',
      },
      {
        keywords: ['ባግ', 'ስህተት', 'ጥገና', 'ብልሽት'],
        question: 'ከምረቃ በኋላ ስህተት (Bug) ቢገኝ ምን ይደረጋል?',
        answer: 'ስራውን ካስረከብን በኋላ ማንኛውንም ቴክኒካዊ ስህተት በነጻ የምናስተካክልበት የዋስትና ጊዜ እንሰጣለን።',
      },
      {
        keywords: ['ባለቤትነት', 'ሶርስ ኮድ', 'መብት', 'ጊትሃብ'],
        question: 'የሶፍትዌሩ ባለቤት ማን ነው?',
        answer: 'የፕሮጀክቱ ክፍያ ተጠናቆ ሲረከቡ የሶርስ ኮዱ (Source Code) እና የፈጠራ ባለቤትነቱ 100% የእርስዎ ይሆናል።',
      },
      {
        keywords: ['ክላውድ', 'ሰርቨር', 'ሆስቲንግ', 'ዌብሳይት ማስቀመጫ'],
        question: 'የትኞቹን የክላውድ አገልግሎቶች ትጠቀማላችሁ?',
        answer: 'እንደ ደንበኛው ፍላጎት AWS፣ Google Cloud፣ DigitalOcean ወይም የሀገር ውስጥ ሆስቲንግ አገልግሎቶችን እንጠቀማለን።',
      },
      {
        keywords: ['ፍጥነት', 'ፐርፎርማንስ', 'ዝግ ያለ', 'ማሻሻያ'],
        question: 'ያለኝን ድረ-ገጽ ፍጥነት ማሻሻል ትችላላችሁ?',
        answer: 'አዎ፣ የፍጥነት ምርመራ በማድረግ ድረ-ገጽዎ እጅግ ፈጣን እንዲሆን የማሻሻያ ስራዎችን እንሰራለን።',
      },
      {
        keywords: ['ሪስፖንሲቭ', 'ታብሌት', 'ስልክ እይታ', 'ስክሪን'],
        question: 'ድረ-ገጹ በስልኮች ላይ ይሰራል?',
        answer: 'አዎ፣ የምንሰራቸው ድረ-ገጾች በኮምፒውተር፣ በታብሌት እና በማንኛውም ስልክ ላይ ተስተካክለው የሚታዩ (Responsive) ናቸው።',
      },
      {
        keywords: ['በሰዓት', 'ቋሚ ዋጋ', 'ውል', 'የክፍያ እቅድ'],
        question: 'የአከፋፈል ሁኔታችሁ እንዴት ነው?',
        answer: 'በደረጃ የተከፋፈለ የክፍያ እቅድ እንጠቀማለን (ለምሳሌ 30% ቅድመ ክፍያ፣ 40% ስራው አጋማሽ ሲደርስ፣ እና 30% ሲጠናቀቅ)።',
      },
      {
        keywords: ['ቅናሽ', 'ርካሽ', 'ድርድር'],
        question: 'ለአነስተኛ ንግዶች ቅናሽ ታደርጋላችሁ?',
        answer: 'ተወዳዳሪ ዋጋ እናቀርባለን፤ እንዲሁም እንደ በጀትዎ የፕሮጀክቱን ስፋት አስተካክለን መስራት እንችላለን።',
      },
      {
        keywords: ['ደረሰኝ', 'ታክስ', 'ቫት', 'ንግድ'],
        question: 'ህጋዊ ደረሰኝ እና የቫት (VAT) ደረሰኝ ትሰጣላችሁ?',
        answer: 'አዎ፣ በኢትዮጵያ ህግ የተመዘገብን ድርጅት ስለሆንን ህጋዊ ደረሰኞችን እናቀርባለን።',
      },
      {
        keywords: ['ንግግር', 'ቪዲዮ ኮል', 'ስብሰባ', 'ዙም'],
        question: 'በቪዲዮ ኮል መወያየት እንችላለን?',
        answer: 'አዎ! በዙም (Zoom) ወይም በጎግል ሚት (Google Meet) በሚመችዎት ሰዓት መወያየት እንችላለን።',
      },
      {
        keywords: ['ቋንቋ', 'እንግሊዝኛ', 'አማርኛ', 'መግባቢያ'],
        question: 'በእንግሊዝኛ መግባባት እንችላለን?',
        answer: 'አዎ፣ ቡድናችን ለአሰራር ምቹ እንዲሆን በአማርኛም ሆነ በእንግሊዝኛ ቋንቋ አቀላጥፎ ይግባባል።',
      },
      {
        keywords: ['ስልጠና', 'አጠቃቀም', 'መመሪያ'],
        question: 'ለሰራተኞቼ ስለ ሲስተሙ ስልጠና ትሰጣላችሁ?',
        answer: 'አዎ፣ ተግባራዊ ስልጠናዎችን እና የአጠቃቀም ቪዲዮዎችን ለቡድንዎ እናቀርባለን።',
      },
      {
        keywords: ['ቡና', 'ቢሮ', 'ጉብኝት'],
        question: 'ቢሮ መጥቼ ቡና እየጠጣን መወያየት እንችላለን?',
        answer: 'በእርግጥ! አዲስ አበባ በሚገኘው ቢሮአችን በኢትዮጵያ ቡና እየተዝናናን ስለ ቴክኖሎጂ ማውራት ደስ ይለናል።',
      },
      {
        keywords: ['ፎርቲኖ', 'ትርጉም', 'ስም'],
        question: 'ፎርቲኖ (Fortino) ማለት ምን ማለት ነው?',
        answer: 'ፎርቲኖ ማለት ጥንካሬ እና ጥበቃ ማለት ነው—ይህም የምንገነባቸውን ጠንካራ እና አስተማማኝ ሶፍትዌሮች ይወክላል።',
      },
    
  ],
};

const DIRECT_ANSWERS = {
  en: {
    office: 'Our office is in Addis Ababa, Jemo Michael, Peony Commercial Building, Office No. 306/A. You are welcome to visit us.',
    cctv: 'Yes. Fortino Tech installs, configures, and maintains CCTV cameras for homes, offices, clinics, shops, and commercial buildings, including remote viewing on your phone.',
    websiteTime: 'A standard business website usually takes 2 to 4 weeks. A larger custom website or web application can take 4 to 8 weeks after we agree on the features.',
    tech: 'We use React, Node.js, Express, MySQL, Python, Flutter, React Native, and other modern tools depending on the project.',
  },
  am: {
    office: 'ቢሮአችን አዲስ አበባ፣ ጀሞ ሚካኤል፣ ፒዮኒ ኮመርሻል ቪልዲንግ፣ ቢሮ ቁጥር 306/A ይገኛል። ለምክክር መጥተው ማግኘት ይችላሉ።',
    cctv: 'አዎ። ፎርቲኖ ቴክ ለቤት፣ ቢሮ፣ ክሊኒክ፣ ሱቅ እና የንግድ ሕንፃዎች የCCTV ካሜራ ተከላ፣ ማስተካከያ እና ከስልክ የርቀት እይታ እንሰጣለን።',
    websiteTime: 'መደበኛ የንግድ ድረ-ገጽ ብዙውን ጊዜ ከ2 እስከ 4 ሳምንታት ይወስዳል። ትልቅ ብጁ ድረ-ገጽ ወይም የድር መተግበሪያ ከ4 እስከ 8 ሳምንታት ሊወስድ ይችላል።',
    tech: 'እንደ ፕሮጀክቱ React፣ Node.js፣ Express፣ MySQL፣ Python፣ Flutter እና React Native እንጠቀማለን።',
  },
}

function scoreKnowledgeItem(question, item) {
  const q = question.toLowerCase()
  const words = new Set(q.replace(/[^\p{L}\p{N}\s]/gu, ' ').split(/\s+/).filter((w) => w.length > 2))
  let score = 0
  item.keywords.forEach((keyword) => {
    const k = String(keyword).toLowerCase()
    if (k.length <= 2) return
    if (k.includes(' ') && q.includes(k)) score += k.length * 6
    else if (words.has(k)) score += k.length * 3
    else if (k.length >= 5 && q.includes(k)) score += k.length
  })
  String(item.question || '').toLowerCase().split(/\s+/).forEach((word) => {
    if (word.length > 2 && words.has(word)) score += 4
  })
  return score
}

export function findAnswer(userQuestion, language = 'en') {
  const q = String(userQuestion || '').toLowerCase().trim()
  const pack = DIRECT_ANSWERS[language] || DIRECT_ANSWERS.en

  if (/(office|location|address|where are you|where is your|ቢሮ|አድራሻ)/i.test(q)) {
    return { question: userQuestion, answer: pack.office, matched: true }
  }
  if (/(cctv|camera|surveillance|ካሜራ|ሴሲቲቪ)/i.test(q)) {
    return { question: userQuestion, answer: pack.cctv, matched: true }
  }
  if (/(how long.*website|website.*take|website.*week|ድረ-ገጽ|ድህረ ገጽ|ዌብሳይት)/i.test(q) && /(take|long|week|time|ቀን|ሳምንት|ስንት)/i.test(q)) {
    return { question: userQuestion, answer: pack.websiteTime, matched: true }
  }
  if (/(technolog|tech stack|what tech|ቴክኖሎጂ)/i.test(q)) {
    return { question: userQuestion, answer: pack.tech, matched: true }
  }

  const knowledge = chatbotKnowledge[language] || chatbotKnowledge.en
  let best = null
  let bestScore = 0
  knowledge.forEach((item) => {
    const score = scoreKnowledgeItem(q, item)
    if (score > bestScore) {
      bestScore = score
      best = item
    }
  })

  if (best && bestScore >= 8) {
    return { question: best.question, answer: best.answer, matched: true }
  }

  return {
    question: userQuestion,
    answer:
      language === 'am'
        ? 'ይቅርታ፣ ለዚህ ጥያቄ ሙሉ መልስ መስጠት አልቻልኩም። በWhatsApp (+251 979 235 206) ወይም Telegram (@fortinotech) በቀጥታ ያግኙን።'
        : 'Sorry, I could not fully answer this question. Please message us on WhatsApp (+251 979 235 206) or Telegram (@fortinotech).',
    matched: false,
  }
}
